import { render, staticRenderFns } from "./videoread.vue?vue&type=template&id=0c00aea6&scoped=true&"
import script from "./videoread.vue?vue&type=script&lang=js&"
export * from "./videoread.vue?vue&type=script&lang=js&"
import style0 from "./videoread.vue?vue&type=style&index=0&id=0c00aea6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c00aea6",
  null
  
)

export default component.exports